var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validated-input"},[_c('input',{class:{invalid: _vm.errorMessage},attrs:{"type":_vm.type,"maxlength":_vm.maxLength,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.modelValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}})])
}
var staticRenderFns = []

export { render, staticRenderFns }